export default "__VITE_ASSET__OPmC2Khm__"